import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Input } from "../ui/input";

const ctl = "h-8 rounded-md bg-slate-900 border border-slate-700 px-2 text-xs text-slate-100";

export default function EmailTemplatePicker({ subject, body, onPick, t }) {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState("");
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState("");
  const filled = subject.trim() && body.trim();

  const load = () => api.get("/admin/email-templates").then((r) => setTemplates(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const pick = (id) => {
    setSelected(id);
    const tpl = templates.find((x) => x.id === id);
    if (tpl) onPick(tpl);
  };
  const save = async () => {
    try {
      const { data } = await api.post("/admin/email-templates", { name: name.trim(), subject, body });
      toast.success(t("admin.emailTemplateSaved"));
      setNaming(false); setName("");
      await load();
      setSelected(data.id);
    } catch (e) { toast.error(e.response?.data?.detail || t("common.error")); }
  };
  const remove = async () => {
    try {
      await api.delete(`/admin/email-templates/${selected}`);
      setSelected("");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || t("common.error")); }
  };
  const current = templates.find((x) => x.id === selected);

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="email-template-picker">
      <select value={selected} onChange={(e) => pick(e.target.value)} className={`${ctl} min-w-[240px]`} data-testid="email-template-select">
        <option value="">{t("admin.emailTemplateNone")}</option>
        {templates.map((tpl) => (
          <option key={tpl.id} value={tpl.id}>{tpl.name}{tpl.is_default ? ` (${t("admin.emailDefaultTag")})` : ""}</option>
        ))}
      </select>
      {current && !current.is_default && (
        <button onClick={remove} className="text-xs text-red-300 hover:text-red-200" data-testid="email-template-delete">{t("admin.emailTemplateDelete")}</button>
      )}
      {naming ? (
        <>
          <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} placeholder={t("admin.emailTemplateName")} className={`${ctl} w-48`} data-testid="email-template-name" />
          <button onClick={save} disabled={!name.trim() || !filled} className="text-xs text-amber-400 hover:text-amber-300 disabled:opacity-40" data-testid="email-template-save-confirm">{t("common.save")}</button>
          <button onClick={() => setNaming(false)} className="text-xs text-slate-400" data-testid="email-template-save-cancel">{t("common.cancel")}</button>
        </>
      ) : (
        <button onClick={() => setNaming(true)} disabled={!filled} className="text-xs text-slate-300 hover:text-amber-300 disabled:opacity-40" data-testid="email-template-save">{t("admin.emailSaveTemplate")}</button>
      )}
    </div>
  );
}
